<template>
  <div id="home" style="left: 0;position: absolute">
    <el-container>
      <el-header>
        <div v-if="isShow2">
          <TopHeader2 />
        </div>
        <div v-else>
          <TopHeader />
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
<!--        <TopTitle />-->
<!--        <br>-->
<!--        <div style="text-align: center;">-->
<!--          <p style="font-weight: bold;font-size: 35px;color: #606266;">提升百倍效率，解放双手让您创造更高价值</p>-->
<!--          <p>13个高效功能涵盖所有高频操作</p>-->
<!--        </div>-->
<!--        <br>-->
<!--        <MenuList />-->
<!--        <br>-->
<!--        <Description />-->
<!--        <br>-->
<!--        <Content />-->
<!--        <br>-->
<!--        <br>-->
      </el-main>
      <el-footer style="height: 150px;width: 100%">
        <Footer />
      </el-footer>
      <el-backtop :bottom="100">▲</el-backtop>
    </el-container>
    <div class="help">
      <el-image :src="img" style="border-radius: 5px"/>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import FixedHeader from '@/components/FixedHeader'

import TopHeader from '@/components/index/TopHeader'
import TopHeader2 from '@/components/index/TopHeader2'
// import TopTitle from '@/components/index/TopTitle'
// import MenuList from '@/components/index/MenuList'
// import Description from '@/components/index/Description'
// import Content from '@/components/index/Content'
import Footer from '@/components/index/Footer'
import img_help from '@/assets/images/qq_small.jpg'
export default {
  name: 'Home',
  components: {
    Footer,
    // Content,
    // Description,
    // MenuList,
    // TopTitle,
    TopHeader,
    TopHeader2
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      img: img_help,
      isShow2: false
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    // 为了避免网站审查，默认进入首页是没有下载页面的
    $route(to, from) {
      console.log(to.path)
      if (this.$route.path === '/index/exe2') {
        this.isShow2 = true
      } else {
        this.isShow2 = false
      }
    }
  },
  created() {
    // console.log(this.$route.path)
    if (this.$route.path === '/index/exe2') {
      this.isShow2 = true
    } else {
      this.isShow2 = false
    }
  }
}
</script>

<style lang="scss" scoped>
#home {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0;
  padding: 0;
  //min-height: 2000px;
  ::v-deep.fixed-header {
    position:fixed;
    top:22px;
    width: 100%;
    z-index:999;
  }
  ::v-deep.top-fixed-header {
    position:fixed;
    background: red;
    color: white;
    top:0;
    width: 100%;
    z-index:999;
  }
  .el-container{
    margin: 0;
    padding: 0;
  }
  .el-header {
    color: #3492ed;
    background-color: white;
    line-height: 70px;
    position:fixed;
    z-index:20;
    width: 100%;
    top:0;
    left: 0;
    box-shadow: 0 5px 3px #eaebec;
  }
  .el-main {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  .el-footer {
    display: flex;
    position: relative;
    color: white;
    line-height: 15px;
    /*background-color: #006cff;*/
    background: #409EFF;;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #1687fc, #409EFF);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #1687fc, #409EFF); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
}
.help{
  position: fixed;
  //display: flow;
  top:70%;
  right: 5px;

  width: 100px;
  height: 100px;
  z-index: 100;
}
.help:hover{
  position: fixed;
  top:70%;
  right: 5px;

  width: 160px;
  height: 160px;
  z-index: 100;
}
</style>

